import axios from "axios";
import { ApiUrlUtil } from "../../utils/apiUrlUtil";
import { ParamUtil, RequestParam } from "../../utils/paramUtil";
import { HeadersUtil } from "../../utils/headersUtil";

export default class Dcs0301Service {
  private static _dcs0301Service: Dcs0301Service;

  public static getInstance(): Dcs0301Service {
    if (!Dcs0301Service._dcs0301Service) {
      Dcs0301Service._dcs0301Service = new Dcs0301Service();
    }
    return Dcs0301Service._dcs0301Service;
  }

  public getList(modelSearch: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(modelSearch);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0301/getLstProtocol.do", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getProtocolDetail(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0301/getProtocolDetail.do", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public updateProtocol(req: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0301/update.do");
    return axios.post(url, req, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public insertProtocol(req: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0301/insert.do");
    return axios.post(url, req, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public delete(req: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0301/deleteProtocol.do");
    return axios.post(url, req, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public updateVersion(req: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0301/updateVersion.do");
    return axios.post(url, req, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public insertVersion(req: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0301/insertVersion.do");
    return axios.post(url, req, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public deleteVersion(verId: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0301/" + verId + "/deleteVersion.do");
    return axios.delete(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getVersionByProtId(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/dcs/dcs0301/getVersionByProtId.do", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }
}
